import { useCallback } from 'react';
import { useAsyncCallback } from '@react-hooks-library/core';

import { fetchEnrollmentDocumentStats } from '@services/protocol';

export const useGetEnrollmentDocumentStats = () => {
  return useAsyncCallback(
    useCallback(async (trialId?: string | null) => {
      try {
        if (!trialId) return;
        const { stats } = (await fetchEnrollmentDocumentStats({ trial_id: trialId })) || {};

        return stats;
      } catch (error) {
        console.error('An Error occurred fetching enrollment document stats', error);
      }
    }, [])
  );
};
